export default "__VITE_ASSET__BqBfEosq__"